import { useTranslation } from 'react-i18next';
import { Button } from './CustomButton/Button';
import { TranslationNS } from '@gokrew/models/constants';
import { AppLoaderPage } from '@gokrew/ui/components/AppLoaderPage';
import { isReloadingForStaleChunk } from '@gokrew/ui/utility/staleChunkReload';

interface ErrorFallbackDialogProps {
  resetError: () => void;
  error?: unknown;
}

export function ErrorFallbackDialog({
  resetError,
  error,
}: ErrorFallbackDialogProps) {
  const isMaxRetry =
    error && typeof error === 'object' && '_isMaxRetry' in error;
  const errorType = isMaxRetry ? 'max_retry' : 'unknown';
  const { t } = useTranslation(TranslationNS.Common);

  // A deploy replaced the code this tab was running and the page is already
  // reloading onto the new build: show the loader, not a false "500".
  if (isReloadingForStaleChunk()) return <AppLoaderPage />;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center space-y-4 max-w-md">
        <div className="text-6xl font-bold text-gray-200" aria-hidden="true">
          500
        </div>
        <h1 className="text-2xl font-semibold text-gray-800">
          {t('error_page.title')}
        </h1>
        <p className="text-sm text-gray-500">
          {errorType === 'max_retry'
            ? t('error_page.max_retry_description')
            : t('error_page.unknown_description')}
        </p>
        <div className="flex gap-3 justify-center pt-2">
          <Button
            variant="outline"
            onClick={() => {
              window.location.href = '/profile';
            }}
          >
            {t('error_page.go_to_profile')}
          </Button>
          <Button variant="primary" onClick={resetError}>
            {t('error_page.retry')}
          </Button>
        </div>
      </div>
    </div>
  );
}
